import { render } from "./HistoryChoiceModal.vue?vue&type=template&id=1f73adcc&scoped=true&ts=true&lang=pug"
import script from "./HistoryChoiceModal.vue?vue&type=script&lang=ts"
export * from "./HistoryChoiceModal.vue?vue&type=script&lang=ts"

import "./HistoryChoiceModal.vue?vue&type=style&index=0&id=1f73adcc&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./HistoryChoiceModal.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/modals/historyChoiceModal.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fmodals%2FHistoryChoiceModal.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f73adcc"]])

export default __exports__